// Keep canonical decimal strings for API/Formik; group only the displayed value.
// Comma is the thousands separator, dot the decimal separator (same as dashboard inputs).
export const parseMoneyInput = (value) => {
  const raw = String(value == null ? '' : value).replace(/,/g, '')
  return /^\d*(?:\.\d{0,2})?$/.test(raw) ? raw : null
}
export const formatMoneyInput = (value) => {
  const raw = String(value == null ? '' : value)
  if (!raw) return ''
  const [ integer, fraction ] = raw.split('.')
  const grouped = integer.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
  return grouped + (fraction === undefined ? '' : '.' + fraction)
}
export const canonicalMoneyInput = (value) => {
  const raw = String(value || '')
  return (raw.startsWith('.') ? '0' + raw : raw).replace(/\.$/, '')
}
